import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sportsData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-live-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-semibold tracking-wide">每日大赛</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              每日大赛在线观看，汇聚全球顶级赛事直播资源。高清免费在线观看足球、篮球、电竞、网球等热门赛事，实时赛程、精彩集锦一站式全覆盖。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/football" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">赛事分类</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">赛事项目</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                <span>support@meiri-dasai.com</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-foreground-400"></i>
                </div>
                <span>400-888-9999</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-foreground-400"></i>
                </div>
                <span>北京市朝阳区体育产业园A座</span>
              </div>
            </div>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 每日大赛在线观看 版权所有 | 京ICP备2026XXXXXX号
          </p>
          <div className="flex gap-5 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}